export default __webpack_public_path__ + "static/media/Cancer-Care-Bg.0860259f.svg";